// extracted by mini-css-extract-plugin
export var boxItems = "_8n-1";
export var boxItemsLg = "_8n-2";
export var button = "_8n-7";
export var buttonHoverless = "_8n-9";
export var buttonLg = "_8n-8";
export var filterGroupBox = "_8n-0";
export var icon = "_8n-3";
export var iconSecondary = "_8n-6";
export var iconWrapper = "_8n-4";
export var iconWrapperLg = "_8n-5";
export var truncatedLabel = "_8n-a";